import { useAtom } from '@reatom/npm-react'

import { walletsAtom } from '@root/entities/wallet/atoms'

import type { ProfileWallet } from '@root/entities/profile/model/profile-wallet'

/**
 * The signed-in account's own wallets, in the shape the profile screen wants.
 *
 * The profile used to take its wallet list from `GET /user/profile`, which was
 * never ported — so the list was empty, the selector had nothing in it, and
 * the analytics below it asked about no wallets at all and sat on a skeleton
 * forever. The wallets are already in the app; this is the same list the
 * wallet manager and the trade panel use.
 *
 * Balances come across because the selector shows them; everything else the
 * old DTO carried is either unused here or unknowable from this side.
 */
export const useOwnProfileWallets = (): ReadonlyArray<ProfileWallet> => {
  const [wallets] = useAtom(
    (ctx) =>
      ctx.spy(walletsAtom).map(
        (wallet): ProfileWallet => ({
          network: wallet.network,
          id: wallet.id,
          address: wallet.address,
          name: ctx.spy(wallet.name),
          color: ctx.spy(wallet.color),
          balance: {
            usd: ctx.spy(wallet.totalBalanceUsd),
            native: ctx.spy(wallet.totalBalanceNative),
          },
          lastSyncedAt: undefined,
        }),
      ),
    [],
  )

  return wallets
}
